<template>
  <div id="app" @click="loadvconsolefn">
    <keep-alive>
      <router-view :key="$route.fullPath"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      contactcount: 0,
    };
  },
  mounted() {
    console.log(3331222, "测试");
    // const vConsole = new VConsole();
    // if (window.location.port != '8080') {
    //   const vConsole = new VConsole();
    // }
  },
  methods: {
    loadvconsolefn() {
      // 联系点击5次显示
      // if (this.contactcount >= 5) {
      //   const vConsole = new VConsole();
      //   console.log(3331222, "测试11");
      // } else {
      //   this.contactcount++;
      // }
    },
  },
};
</script>

<style lang="scss">
/* app专用字体 */
@font-face {
  font-family: 'Outfit';
  src: url('https://resources1.interface003.com/web20/font/Outfit/Outfit-VariableFont_wght.ttf');
  font-display: swap;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
</style>
